import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { BorderRadiusDsType } from '@design-system/entities/border-radius.type';
import { BackgroundSurfaceType } from '@design-system/components/atoms/background-surface/entities/background-surface.types';

@Component({
  selector: 'app-ds-background-surface',
  templateUrl: './background-surface.component.html',
  styleUrls: ['./background-surface.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class BackgroundSurfaceDsComponent {

  @Input() type = BackgroundSurfaceType.Primary;
  @Input() boxShadow = false;
  @Input() height = null;
  @Input() width = null;
  @Input() position = 'relative';
  @Input() top = null;
  @Input() bottom = null;
  @Input() left = null;
  @Input() right = null;
  @Input() padding = null;
  @Input() margin = null;
  @Input() borderRadius: BorderRadiusDsType = null;

  constructor() { }

}
